module.exports = __webpack_public_path__ + "img/liebian_bg01.058127ec.png";